import { Logout as Logout_kojaro } from './Logout.kojaro';
import { Logout as Logout_phosphor } from './Logout.phosphor';
import { Logout as Logout_zoomg } from './Logout.zoomg';
import { Logout as Logout_zoomit } from './Logout.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Logout_kojaro;

    case 'zoomg':
      return Logout_zoomg;

    case 'phosphor':
      return Logout_phosphor;

    default:
      return Logout_zoomit;
  }
};

export const Logout = IconRenderer();
